<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <table class="login-layout"><!-- //NOSONAR -->
    <tr>
      <td class="login-right">
        <div class="login-content">
          <div class="login-header">
            <div class="login-app-logo" />
          </div>
          <div class="login-body">
            <div class="title">{{ message }}</div>
            <div class="change-password-content">
              <!-- <div class="change-password-message">{{message}}</div> -->
              <el-form class="form" ref="form" :model="form" :rules="formRules">
                <div>
                  <div class="password-title">{{ $t('login.changePassword.currentPassword') }}</div>
                  <el-form-item  prop="currentPassword">
                    <el-input :type="currentPasswordType" v-model="form.currentPassword" :placeholder="$t('account.currentPassword.placeholder')" size="medium"></el-input>
                    <el-button :class="{'login-eye': true, 'login-eye-on': (currentPasswordType=='text')}" @click="toggleCurrentPasswordVisibility"></el-button>
                  </el-form-item>
                  <div class="password-title">{{ $t('login.resetPassword.newPassword') }}</div>
                  <el-form-item  prop="newPassword">
                    <el-input :type="newPasswordType" v-model="form.newPassword" :placeholder="$t('account.newPassword.placeholder')" size="medium"></el-input>
                    <el-button :class="{'login-eye': true, 'login-eye-on': (newPasswordType=='text')}" @click="toggleNewPasswordVisibility"></el-button>
                  </el-form-item>
                  <div class="password-title">{{ $t('login.resetPassword.confirmPassword') }}</div>
                  <el-form-item prop="newPasswordConfirm">
                    <el-input :type="confirmPasswordType" v-model="form.newPasswordConfirm" :placeholder="$t('account.newPasswordConfirm.placeholder')" size="medium"></el-input>
                    <el-button :class="{'login-eye': true, 'login-eye-on': (confirmPasswordType=='text')}" @click="toggleConfirmPasswordVisibility"></el-button>
                  </el-form-item>
                </div>
              </el-form>
              <div class="form-buttons">
                <el-button class="wy-blue-button login-button" @click="handleUpdate" :loading="isLoading">{{ $t('button.confirm') }}</el-button>
                <el-button class="wy-grey-button login-button" @click="handleCancel" :disabled="isLoading">{{ $t('button.cancel') }}</el-button>
              </div>
              <div class="login-password-hints">
                <div class="title">{{ $t('account.hints.passwordFormatTitle') }}</div>
                <div class="desc" v-html="$t('account.hints.passwordFormatDesc')"></div>              
              </div>
            </div>   
          </div>     
        </div>
      </td>
    </tr>
  </table>
</template>

<script>
import Vue from 'vue';

export default Vue.extend ({
  name: 'change-password',
  props: ['code', 'email', 'message'],

  data() {
    return {
      form: {
        currentPassword: '',
        newPassword: '',
        newPasswordConfirm: ''
      },
      formRules: {
        currentPassword: [
          { validator: (rule, value, callback) => {
            if (!value) {
              callback(Vue.i18n.translate('account.currentPassword.validateEmpty'));
            } else {
              callback();
            }
          }, required: true, trigger: ['blur', 'change']}
        ],
        newPassword: [
          { validator: (rule, value, callback) => {
            this.$root.passwordValidator(value, callback)
          }, required: true, trigger: ['blur', 'change']}
        ],
        newPasswordConfirm: [
          { validator: (rule, value, callback) => {
            this.$root.passwordConfirm(this.form.newPassword, value, callback)            
          }, required: true, trigger: ['blur', 'change']}
        ]
      },
      currentPasswordType: 'password',
      newPasswordType: 'password',
      confirmPasswordType: 'password',
      isLoading: false
    }
  },
  methods: {
    handleCancel() {
      this.$router.push({name: 'login'});
    },

    toggleCurrentPasswordVisibility() {
      this.currentPasswordType = (this.currentPasswordType == 'password') ? 'text' : 'password';
    },
    toggleNewPasswordVisibility() {
      this.newPasswordType = (this.newPasswordType == 'password') ? 'text' : 'password';
    },
    toggleConfirmPasswordVisibility() {
      this.confirmPasswordType = (this.confirmPasswordType == 'password') ? 'text' : 'password';
    },

    async handleUpdate() {
      this.$refs.form.validate(async (isValid) => {
        if (isValid) {
          let data = {
            "email": this.email,
            "oldPassword": this.form.currentPassword, 
            "newPassword": this.form.newPassword,
            "confirmPassword": this.form.newPasswordConfirm,
            "code": this.code
          }
          let res = await this.$store.dispatch('authUpdatePassword', data);
          if(res && res.status === 200){
            this.$root.showNotificationLocale("success", "login.resetPassword.resetPasswordSuccessTitle", "login.resetPassword.resetPasswordSuccessMsg");

            setTimeout(() => {
              if(res.data.token && res.data.token != "") {
                this.$router.push({path: '/default'});
              }
              else {
                this.$router.push({path: '/'})
              }
            }, 500)
          }
          else if(res.data && res.data.errorCode) {
            this.$root.showNotificationLocale("error", null, `errorCode.code${res.data.errorCode}`);
          }
          else {
            this.$root.showNotificationLocale("error", 'error.serverErrorTitle', 'error.serverErrorMsg');
          }
        }
      });
    }
  },

  created() {
    if(!this.email || this.email == '') {
      this.$router.push({path: '/'});
    }
  }
})
</script>

<style lang="scss">
.wy-changePassword-page {
  overflow-y: auto;
  .login-layout {
    min-height: 745px;
  }
  background-color: #0C2837;
  background-image: url('../assets/images/login_bg_owl.svg') !important;

  background-size: 42% 130%;
  background-repeat: no-repeat;
  // background-position-x: 1145px;
  // background-position-y: -223px;
  background-position-x: 108%;
  background-position-y: 49.1%;
  // .login-content {
    // > .title {
    //   font-size: 34px;
    //   font-family: sans-serif;
    //   vertical-align: middle;
    //   color: #214586;
    //   background-image: url('../assets/icons/alert_lock.svg');
    //   background-repeat: no-repeat;
    //   background-size: 50px 50px;
    //   background-position: 0px 0px;
    //   height: 55px;
    //   padding-left: 70px;
    //   padding-top: 7px;
    // }
    // .form {
    //   margin-top: 8px;
    //   .password-title {
    //     font-size: 20px;
    //     color: #214586;
    //     font-weight: 600;
    //     padding-top: 10px;    
    //     text-align: left;
    //   }
    // }
    // .form-buttons {
    //   padding-top: 10px;
    // }

    // .change-password-message {
    //   color: #ce2525;
    //   font-style: italic;
    // }
  // }
  .login-content {
    margin-top: 55px !important;
    > .title {
      font-size: 34px;
      font-family: sans-serif;
      vertical-align: middle;
      color: #214586;
      background-image: url('../assets/icons/alert_lock.svg');
      background-repeat: no-repeat;
      background-size: 50px 50px;
      background-position: 0px 0px;
      height: 55px;
      padding-left: 70px;
      padding-top: 7px;
    }
    .title {
      font-size: 16px;
      color: #CA1053;
      font-weight: 400;
    }
    .form {
      margin-top: 25px;
      .password-title {
        font-size: 14px;
        color: #214586;
        font-weight: 700;
        padding-top: 0px;    
        text-align: left;
      }
      .login-eye {
        background-image: url("../assets/images/login_eye.svg");
        background-position-x: 0px;
        background-position-y: 3px;
        background-repeat: no-repeat;
        padding: 10px 10px 10px 10px;
        margin: 0px;
        background-color: transparent;
        border: 0;
        position: relative;
        left: 263px;
        top: -32px;
      }
      .login-eye.login-eye-on {
        background-image: url("../assets/images/login_eye_on.svg");
      }
      .el-form-item {
        margin-bottom: 0px;
        margin-top: 8px;
        input.el-input__inner {
          border-width: 1px !important;
          height: 36px;
          border-radius: 5px;
        }
        .el-form-item__content {
          line-height: 15px;
        }
        .el-form-item__error {
          // position: relative;
          top: 38px;
        }
      }
    }
    .form-buttons {
      padding-top: 10px;
      .wy-blue-button{
        width: 100%;
        display: block;
        padding: 15px 30px 15px 30px;
      }
      .wy-grey-button{
        width: 100%;
        margin-left: 0px;
        margin-top: 10px;
        padding: 12px 30px 12px 30px;
        background: unset;
        -webkit-box-shadow: unset;
        box-shadow: unset;
        border: 1px solid #ddd;
      }
    }
  }
  .login-content {
    padding: 40px;
    width: 380.48px !important;
    height: 423px;
    left: calc(50% - 229px);
    position: inherit;
  }
  
  .login-body {
    -webkit-box-shadow: -6px 0px 20px #1d1541;
    box-shadow: -6px 0px 20px #1d1541;
    border-radius: 5px;
    background: #FFFFFF;
    padding: 40px 40px;
    margin-top: 10px;
    width: 298px;
    max-height: 508px;
    height: fit-content;
    
    .mfa-title {
      color: #214586;
      font-size: 26px;
      margin-bottom: 5px;
    }
    .mfa-desc {
      margin-bottom: 5px;
    }
    .mfa-input {
      margin-top: 10px;
      margin-bottom: 20px;
    }
    .mfa-button {
      text-align: right;
    }

    .login-password-hints {
      margin-top: 21px !important;
      background-image: url('../assets/icons/alert_lock.svg');
      background-repeat: no-repeat;
      background-size: 31px 31px;
      background-position: 0px 0px;
      height: 85px;
      padding-left: 52px;
      padding-top: 1px;

      .title {
        font-size: 14px !important;
        font-weight: 700 !important;
        color: var(--site-font-primary-color);
      }
      .desc {
        font-size: 14px !important;
      }
    }
  }

  .login-app-logo {
    width: 330px !important;
    height: 110px !important;
    background-image: var(--header-logo);
    background-size: 330px 77px;
    background-repeat: no-repeat;
  }

  
  .login-error {
    margin-bottom: 25px;
    font-size: 16px;
    font-weight: 400;
    text-align: left;
    .wy-link-click {
      cursor: pointer;
      text-decoration: underline;
    }
  }
  .login-error-relogin .wy-blue-button {
    width: 100%;
    margin-top: 20px;
    padding: 18px 30px 18px 30px;
  }
}
</style>